<div class="conversation-types-settings">
  <h1>{{ 'SETTINGS.CONVERSATION_TYPES.TITLE' | translate }}</h1>

  <div class="actions">
    <orbit-button
      [icon]="faPlus"
      label="{{ 'SETTINGS.CONVERSATION_TYPES.ADD_TYPE' | translate }}"
      (click)="onAdd()"></orbit-button>
  </div>
  @let loadingValue = loading();

  @if (!loadingValue) {
    <div class="types-table-container">
      <table class="types-table">
        <thead>
          <tr>
            <th>{{ 'SETTINGS.CONVERSATION_TYPES.NAME' | translate }}</th>
            <th>{{ 'SETTINGS.CONVERSATION_TYPES.DESCRIPTION' | translate }}</th>
            <th>{{ 'SETTINGS.CONVERSATION_TYPES.ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (type of conversationTypes()?.conversationTypes; track type.id) {
            <tr>
              <td>{{ type.id }}</td>
              <td>{{ type.description || '-' }}</td>
              <td class="actions-cell">
                <orbit-button
                  [icon]="faEdit"
                  title="{{ 'SETTINGS.CONVERSATION_TYPES.EDIT_TYPE' | translate }}"
                  (click)="onEdit(type)"></orbit-button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
